import {
  CircularProgress
} from '@material-ui/core';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getClientId } from 'store/selectors/userSelector';
import { showNotification } from 'store/slices/snackbar/snackbarSlice';
import { axiosHelperWithToken } from 'utils/axios';
import { updateUserSubscription } from "store/slices/user/userSlice";
import { StatusTypes } from 'constants/StatusTypes';

const PaymentSuccess = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const clientId = useSelector(getClientId);

  useEffect(() => {
    const axios = axiosHelperWithToken();
    axios.post(`/Subscription/update-client-subscription`, {
      clientId,
      status: true
    }).then(() => {
      dispatch(updateUserSubscription(StatusTypes.ACTIVE));
      history.push('/client-dashboard')
    }).catch((err) => {
      dispatch(showNotification({ message: String(err && err?.data?.response?.message), variant: "error" }));
    })
  }, [clientId, dispatch, history]);

  return (
    <div style={{textAlign: 'center', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <div style={{flex: '1'}}>
        <h1 style={{marginTop: '0px'}}>Signup was successful</h1>
        <p>Please wait to be redirected</p>
        <CircularProgress color="primary" />
      </div>
    </div>
  );
}

export default PaymentSuccess
